import script from "./AppVerticalScrollGradient.vue?vue&type=script&setup=true&lang=js"
export * from "./AppVerticalScrollGradient.vue?vue&type=script&setup=true&lang=js"

import "./AppVerticalScrollGradient.vue?vue&type=style&index=0&id=4177677a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4177677a"]])

export default __exports__